export const CDN_SERVICE_TOKEN = 'CDN_SERVICE';

export interface ICdnService {
  supportsCdnTransform(url: string): boolean;
}
